import ListPage from "components/ListPage/ListPage";
import { useRemoteResource } from "hooks/useRemoteResource";
import withRouter from "hoc/withRouter";
import { Card, CardContent, CircularProgress } from "@mui/material";
import reviewsService from "services/admin/reviewsService";
import { useEffect } from "react";
import { toDate } from "helpers/dateHelper";

const ReviewList = () => {
  const [data, loadData, loading] = useRemoteResource(reviewsService.getAll, "");

  useEffect(() => {

  }, [])


  if (loading) {
    return <div className="text-center"><CircularProgress></CircularProgress></div>
  }

  return (
    <ListPage pageTitle="Список отзывов">
      {data?.map(r => {
        return <div className="m-b-16"><Card>
          <CardContent>
            <div>{r.customer?.lastName} {r.customer?.firstName}</div>
            <div className="m-t-8 fs-14 color-gray m-b-16">
              {r.comment}
            </div>
            <div>{toDate(r.createdAt)}</div>
          </CardContent>
        </Card></div>
      })}
    </ListPage>
  );
};

export default withRouter(ReviewList);
